import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import styles from './MultiStepFormStep.module.css';
import { Step } from '../MultiStepForm';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';

interface MultiStepFormStepProps {
    step: Step;
    index: number;
    stepNumber: number;
    isActive: boolean;
    isCompleted: boolean;
    className?: string;
    titleClassName?: string;
    titleContainerClassName?: string;
    contentClassName?: string;
    onEdit: (step: number) => void;
}

export const MultiStepFormStep: React.FC<MultiStepFormStepProps> = props => {
    const editHandler = () => {
        if (!props.isCompleted) return;
        props.onEdit(props.index);
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            <div
                className={clsx(
                    styles.titleContainer,
                    { [styles.completed]: props.isCompleted },
                    props.titleContainerClassName
                )}
                onClick={editHandler}
            >
                <h6 className={clsx(styles.title, props.titleClassName)}>
                    {!props.isCompleted && <span className={styles.stepNumber}>{props.stepNumber}</span>}
                    {props.isCompleted && (
                        <span className={clsx(styles.stepNumber, styles.completedIcon)}>
                            <FontAwesomeIcon icon={faCheck} />
                        </span>
                    )}

                    {props.step.title}

                    {props.step.tooltip && (
                        <Tooltip
                            content={props.step.tooltip}
                            placement="bottom"
                            className={styles.customTooltip}
                        >
                            <div>
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    className={styles.tooltipIcon}
                                />
                            </div>
                        </Tooltip>
                    )}
                </h6>
                {props.isCompleted && <span className={styles.editButton}>Edit</span>}
            </div>
            {props.isActive && (
                <div className={clsx(styles.contentContainer, props.contentClassName)}>
                    {props.step.description && <p className={styles.description}>{props.step.description}</p>}
                    {props.step.component}
                </div>
            )}
        </div>
    );
};
